import { AppleBackdropExpVariants } from '.';

export const validateAppleBackdropExperiment = (appleBackdropExpVariant: string) => {
	return (
		appleBackdropExpVariant === AppleBackdropExpVariants.VARIANT_1 ||
		appleBackdropExpVariant === AppleBackdropExpVariants.VARIANT_2 ||
		appleBackdropExpVariant === AppleBackdropExpVariants.CONTROL
	);
};

export const appleIds = [350, 2];
